import type { PublicRoadmapData } from '@mogul/api-client';
import React from 'react';

import styles from './Timeline.module.css';

interface Props {
  roadmap: PublicRoadmapData;
  index: number;
  length: number;
}

export const TimelineComponent: React.FC<Props> = props => {
  const { roadmap, length, index } = props;

  return (
    <div className={styles.timelineItem}>
      <div className={styles.timelineItemContent}>
        <div className={styles.header}>
          {index !== 0 && (
            <div className={'text-lg font-semibold ' + styles.title}>
              {roadmap.title}
            </div>
          )}
        </div>
        <div className={styles.lineCircleContainer}>
          <div className={styles.underline} />
          <div className={styles.leftPointerContainer}>
            <div className={`${styles.circle} ${styles.leftPointer}`} />
          </div>
          <div className={styles.rightPointerContainer}>
            <span className={`${styles.circle} ${styles.rightPointer}`} />
          </div>
        </div>
        {index !== length && (
          <div className={styles.content}>
            <div className={styles.innerContent}>
              <div className={'font-semibold mb-1'}>{roadmap.label}</div>
              <span className="text-sm">{roadmap.description}</span>
            </div>
            <div className={styles.imageContainer}>
              <img
                src={roadmap.image?.publicUrl.replace(
                  'd8r7g9tzupsfa',
                  'd2bhvhyqzg9zio',
                )}
                className={styles.image}
                alt=""
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
